"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Block2_exports = {};
__export(Block2_exports, {
  default: () => Block2_default
});
module.exports = __toCommonJS(Block2_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.5 2.75C9.47135 2.75 8.5013 2.94531 7.58984 3.33594C6.67839 3.72656 5.8776 4.26693 5.1875 4.95703C4.51042 5.63411 3.97656 6.42839 3.58594 7.33984C3.19531 8.2513 3 9.22135 3 10.25C3 11.2786 3.19531 12.2487 3.58594 13.1602C3.97656 14.0716 4.51042 14.8724 5.1875 15.5625C5.8776 16.2396 6.67839 16.7734 7.58984 17.1641C8.5013 17.5547 9.47135 17.75 10.5 17.75C11.5286 17.75 12.4987 17.5547 13.4102 17.1641C14.3216 16.7734 15.1159 16.2396 15.793 15.5625C16.4831 14.8724 17.0234 14.0716 17.4141 13.1602C17.8047 12.2487 18 11.2786 18 10.25C18 9.22135 17.8047 8.2513 17.4141 7.33984C17.0234 6.42839 16.4831 5.63411 15.793 4.95703C15.1159 4.26693 14.3216 3.72656 13.4102 3.33594C12.4987 2.94531 11.5286 2.75 10.5 2.75ZM4.50391 10.25C4.50391 9.41667 4.66016 8.63542 4.97266 7.90625C5.28516 7.17708 5.70833 6.54557 6.24219 6.01172C6.78906 5.46484 7.42708 5.03516 8.15625 4.72266C8.88542 4.41016 9.66667 4.25391 10.5 4.25391C11.1901 4.25391 11.8477 4.36458 12.4727 4.58594C13.0977 4.80729 13.6641 5.11979 14.1719 5.52344L5.77344 13.9219C5.35677 13.401 5.03776 12.8281 4.81641 12.2031C4.60807 11.5651 4.50391 10.9141 4.50391 10.25ZM10.5 16.2461C9.8099 16.2461 9.15234 16.1354 8.52734 15.9141C7.90234 15.6927 7.33594 15.3802 6.82812 14.9766L15.2266 6.57812C15.6432 7.09896 15.9557 7.67839 16.1641 8.31641C16.3854 8.94141 16.4961 9.58594 16.4961 10.25C16.4961 11.0833 16.3398 11.8646 16.0273 12.5938C15.7148 13.3229 15.2852 13.9609 14.7383 14.5078C14.2044 15.0417 13.5729 15.4648 12.8438 15.7773C12.1146 16.0898 11.3333 16.2461 10.5 16.2461Z",
      fill: "currentColor"
    }
  )
);
const SvgBlock2 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Block2_default = SvgBlock2;
